import { PictureComponentV2 } from 'app/components/commons/PictureComponentV2/PictureComponentV2';
import { StaycationLogoIcon } from 'app/components/commons/icons/StaycationLogoIcon';

import { Arrow } from './Arrow';
import styles from './ConnectivityToStaycation.module.scss';

type ConnectivityToStaycationProps = {
  icon?: React.ReactNode;
};

export const ConnectivityToStaycation = ({
  icon,
}: ConnectivityToStaycationProps) => (
  <div className={styles.connectivityToStaycation}>
    <div className={styles.iconBox}>
      {icon ? (
        icon
      ) : (
        <PictureComponentV2
          path="static/icons/booking.png"
          alt="Booking.com logo"
          className={styles.bookingLogo}
        />
      )}
    </div>
    <Arrow />
    <div className={styles.iconBox}>
      <StaycationLogoIcon />
    </div>
  </div>
);
